export const ROUTES = {
  home: '/',
  terms: '/terms',
  rentalTerms: '/rental-terms',
  privacy: '/privacy',
  deleteAccount: '/delete-account',
  childSafety: '/child-safety',
  support: '/support',
  unsubscribe: '/unsubscribe',
  acceptInvite: '/accept-invite',
  login: '/login',
  dashboard: '/dashboard',
  analytics: '/analytics',
  users: '/users',
  rentals: '/rentals',
  moderation: '/moderation',
  campuses: '/campuses',
  notifications: '/notifications',
  contactMessages: '/contact-messages',
  payments: '/payments',
  settings: '/settings',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
